module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"instruction":"Is it happening now (actual) or is it a potential impact?  "},"de":{"instruction":"Geschieht dies jetzt (aktuell) oder ist es ein potenzieller Einfluss?  "}}')
  delete Component.options._Ctor
}
